import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {parseAxiosPromise} from '@/axiosInstance.ts'
import {httpUploadMediaLink} from '@features/video-upload/http/videoUpload.http.ts'
import {raise} from '@utilities/helpers.ts'
import {captureException} from '@sentry/react'
import {z} from 'zod'
import {Media} from '@features/video-upload/types.ts'

const Response = z.object({
    media: Media,
    presigned_url: z.string().url()
})
type Response = z.infer<typeof Response>

export const useUploadMediaLink = (
    options?: Omit<
        UseMutationOptions<Response, unknown, {assignmentId: number | null; fileName?: string}>,
        'mutationFn'
    >
) =>
    useMutation({
        mutationFn: ({assignmentId, fileName}) =>
            parseAxiosPromise({
                axiosPromise: httpUploadMediaLink({
                    urlParams: {assignmentId: assignmentId ?? raise('assignmentId is nullish')},
                    payload: {media: fileName ?? raise('media is nullish')}
                }),
                onZodError: captureException,
                responseShape: Response
            }),
        ...options
    })
